import React from 'react';

import { SVGComponentProps } from './svg.types';

const VisibilitySVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M14.9775 16.0392L12.4605 13.5222C11.3746 14.0166 10.1931 14.2658 9 14.252C7.76991 14.2672 6.55253 14.0018 5.4405 13.4757C4.57851 13.0551 3.80448 12.4743 3.15975 11.7642C2.47537 11.0306 1.93747 10.173 1.575 9.23745L1.5 9.00195L1.57875 8.76495C2.12086 7.38217 3.03319 6.17533 4.21575 5.2767L2.25 3.31095L3.30975 2.25195L16.0365 14.9787L14.979 16.0392H14.9775ZM5.277 6.3387C4.31844 7.01064 3.56149 7.93149 3.08775 9.00195C4.10356 11.3456 6.4469 12.832 9 12.752C9.78737 12.7584 10.5702 12.6316 11.3153 12.377L9.96525 11.027C9.66475 11.1743 9.33466 11.2512 9 11.252C7.76059 11.2442 6.75778 10.2414 6.75 9.00195C6.75036 8.66653 6.82732 8.33562 6.975 8.03445L5.277 6.3387ZM14.889 11.7095L13.845 10.6662C14.2842 10.1696 14.6442 9.60829 14.9122 9.00195C13.8978 6.65714 11.5536 5.17026 9 5.25195C8.81475 5.25195 8.62875 5.2587 8.44875 5.27145L7.125 3.9462C7.74122 3.81438 8.36984 3.74925 9 3.75195C10.2301 3.73669 11.4475 4.00217 12.5595 4.5282C13.4215 4.94875 14.1955 5.5296 14.8403 6.2397C15.5243 6.97243 16.0622 7.82901 16.425 8.76345L16.5 9.00195L16.4213 9.23895C16.0701 10.1525 15.5506 10.992 14.8898 11.714L14.889 11.7095Z"
        fill={fill}
      />
    </svg>
  );
};

export default VisibilitySVG;
